import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {DefaultEntityLanding} from '@catcore/shared/default-entity-landing';
import {GenericLinkedResource} from '@catcore/types/base';
import {genericResourceToLinkItem} from '@catcore/utils';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {Parameter} from '@catmodules/models/parameters/types';
import {ProjectFeatureService} from '@catmodules/models/project-feature/services/project-feature.service';
import {ProjectFeature} from '@catmodules/models/project-feature/types';
import {ProjectUnitsService} from '@catmodules/models/project-units/services/project-units.service';
import {ProjectUnit} from '@catmodules/models/project-units/types';
import {ModifyUnitComponent} from '@catmodules/models/units/components/modify-unit/modify-unit.component';
import {ModalService} from '@catmodules/widgets/slide-in-modal/services/modal.service';
import {LinkItem} from '@catui/types';
import {Subscription} from 'rxjs/Subscription';
import {isNullOrUndefined} from 'util';

const EntitySchemaTypeRef = 'ProjectUnits';
const selfTitle = 'Project Units';

@Component({
  templateUrl: './project-parameters-landing.component.html',
})
export class ProjectParametersLandingComponent extends DefaultEntityLanding<ProjectUnit> implements OnInit {

  linkedParameters: LinkItem[] = [];
  unitSubscription: Subscription;
  projectParameters: Parameter[];
  projectUnit: ProjectUnit;

  private currentResourceService;

  constructor(
    schemaService: EntitySchemaService,
    private unitService: ProjectUnitsService,
    private genericService: GenericResourceService,
    private modalService: ModalService,
  ) {
    super(schemaService);
    this.setSelfTitle(selfTitle);

  }

  ngOnInit() {
    this.currentResourceService = this.genericService.findServiceForResource(this.getParentResourceId());

    this.currentResourceService
      .getCurrent()
      .subscribe((projectUnit: ProjectUnit) => {
        if (!isNullOrUndefined(projectUnit)) {
          this.projectUnit = projectUnit;
          this.projectParameters = this.unitService.extractParametersFor(projectUnit);
          // const projectParameters = this.unitService.extractParametersFor(projectUnit);
          // this.linkedParameters = genericResourceToLinkItem(projectParameters, (value: GenericLinkedResource) => (router: Router) => this.openModifyUnitDialog(value));

        }
      });
  }

  private refreshResource() {
    this.currentResourceService.refresh();
  }

  private openModifyUnitDialog(unitResource: GenericLinkedResource) {
    this.openDialog(unitResource, (unit) => this.unitModalFactory(unit));
  }

  private unitModalFactory(unit) {
    const compRef = this.modalService.open(ModifyUnitComponent);
    compRef.componentInstance.unit = unit;
    compRef.componentInstance.enableDelete = false;
    compRef.componentInstance.afterUpdate.subscribe((updatedUnit) => this.refreshResource());
    return compRef;
  }

  private openDialog(resource: GenericLinkedResource, componentFactory) {
    let compRef;
    const onFullfill = () => {
      resourceHandler.refresh();
      this.unitSubscription.unsubscribe();
    };

    const onError = () => {
      this.unitSubscription.unsubscribe();
    };

    const resourceHandler = this
      .genericService
      .findServiceForResource(resource.href);

    this.unitSubscription = resourceHandler
      .getCurrent()
      .subscribe((item) => {
        if (compRef) {
          compRef.close();
          compRef = null;
        }

        if (isNullOrUndefined(item)) {
          compRef = null;
        } else {
          compRef = componentFactory(item);
          compRef.result.then(onFullfill, onError);
        }
      });

    if (!resourceHandler.isReady()) {
      resourceHandler.load();
    }
  }

  getEntitySchemaTypeRef() {
    return EntitySchemaTypeRef;
  }

}

//    const



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/components/landing-pages/project-parameters-landing/project-parameters-landing.component.ts